import { useMemo } from 'react';
import cns from 'classnames';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { ChevronRightIcon, ExclamationmarkSmallCircleIcon } from '@zep/icons';
import { Colors } from '@zep/ui-tokens';
import { StoreCategoryString } from '../../../../consts';
import { StoreItemType } from '../../../../types/StoreTypes';
import S from './UploadHeader.module.scss';
const UploadHeader = (props: AssetUploadHeaderProps) => {
  const {
    uploadType,
    inputStep
  } = props;
  const {
    t
  } = useTranslation(['store']);
  const isAssetType = uploadType === StoreCategoryString.map || uploadType === StoreCategoryString.object;
  const title = useMemo(() => {
    let bindingType: string = t('store:store_asset_map');
    switch (uploadType) {
      case StoreCategoryString.object:
        bindingType = t('store:store_asset_object_set');
        break;
      case StoreCategoryString.app:
        bindingType = t('store:store_asset_app');
        break;
      case StoreCategoryString.game:
        bindingType = t('store:store_asset_game');
        break;
    }
    return t('store:store_upload_something', {
      x: bindingType
    });
  }, [t, uploadType]);
  const guideMessage = useMemo(() => {
    let message: string = t('store:store_script_guide_description');
    if (isAssetType) {
      message = uploadType === StoreCategoryString.map ? t('store:store_map_guide_description') : t('store:store_object_guide_description');
    }
    return message;
  }, [isAssetType, t, uploadType]);
  const guideLinkTitle = useMemo(() => {
    let message: string = t('store:store_script_guide');
    if (isAssetType) {
      message = uploadType === StoreCategoryString.map ? t('store:store_map_guide') : t('store:store_object_guide');
    }
    return message;
  }, [isAssetType, t, uploadType]);
  const guideLinkUrl = useMemo(() => {
    let message: string = t('store:store_app_guide_link');
    if (isAssetType) {
      message = uploadType === StoreCategoryString.map ? t('store:store_map_guide_link') : t('store:store_object_guide_link');
    }
    return message;
  }, [isAssetType, t, uploadType]);
  return <>
      <header className={S.header}>
        <h1 className={S.title}>{title}</h1>

        <nav className={S.breadcrumb} aria-label="breadcrumb">
          <ol className={S.list}>
            <li aria-current={inputStep === 'common' ? 'step' : 'false'} className={cns(S.item, {
            [S.active]: inputStep === 'common'
          })}>
              {t('store:store_common_information')}
              <ChevronRightIcon width={16} height={16} fill={Colors.PrimaryDefault} data-sentry-element="ChevronRightIcon" data-sentry-source-file="UploadHeader.tsx" />
            </li>
            <li aria-current={inputStep === 'detail' ? 'step' : 'false'} className={cns(S.item, {
            [S.active]: inputStep === 'detail'
          })}>
              {t('store:store_more_information')}
            </li>
          </ol>
        </nav>
      </header>

      <div className={S.guide_wrapper}>
        <ExclamationmarkSmallCircleIcon fill={Colors.RedDefault} width={20} height={20} data-sentry-element="ExclamationmarkSmallCircleIcon" data-sentry-source-file="UploadHeader.tsx" />
        <span className={S.guide_text}>{guideMessage}</span>
        <Link href={guideLinkUrl} target="_blank" className={S.guide_link} rel="noreferrer" prefetch={false} data-sentry-element="Link" data-sentry-source-file="UploadHeader.tsx">
          {guideLinkTitle}
          <ChevronRightIcon width={18} height={18} fill={Colors.PrimaryDefault} data-sentry-element="ChevronRightIcon" data-sentry-source-file="UploadHeader.tsx" />
        </Link>
      </div>
    </>;
};
export default UploadHeader;
type AssetUploadHeaderProps = {
  uploadType: StoreItemType;
  inputStep: string;
};